import type { BranchConnection } from '../@types/BranchConnection';
import type { Actions } from '../actions';
import { REQ_BRANCH } from '../actions/branch';
import {
  RCV_BRANCH_CONNECTION_LIST,
  RCV_CREATE_BRANCH_CONNECTION,
  RCV_REMOVE_BRANCH_CONNECTION,
  REQ_BRANCH_CONNECTION_LIST,
  REQ_CREATE_BRANCH_CONNECTION,
  REQ_REMOVE_BRANCH_CONNECTION,
  REQUEST_FAILED,
} from '../actions/branch-connection';
import { requestStatus, responseStatus } from '../shared/statuses';

interface BranchConnectionState {
  requestStatus: number;
  responseStatus: number;
  list: BranchConnection[];
}

const _initialState: BranchConnectionState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  list: [],
};

const connectionsReducer = (
  state: BranchConnectionState = _initialState,
  action: Actions,
): BranchConnectionState => {
  switch (action.type) {
    case REQ_BRANCH_CONNECTION_LIST:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_BRANCH_CONNECTION_LIST:
      return {
        ...state,
        list: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_CREATE_BRANCH_CONNECTION:
      return {
        ...state,
        requestStatus: requestStatus.CREATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_CREATE_BRANCH_CONNECTION:
      return {
        ...state,
        list: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_REMOVE_BRANCH_CONNECTION:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_REMOVE_BRANCH_CONNECTION:
      return {
        ...state,
        list: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_BRANCH:
      return { ...state, list: [] };
    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default connectionsReducer;
